import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getTranslation } from '../../../utils/translations';
import { Select } from '../../select';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { changeRound } from 'common/store/modules/competition-nav/thunks/change-round';

export const RoundSelectNavItem = ({
    removeFinals,
    className,
    hideLabel = true
}) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    const roundsFromStore = nav?.rounds;
    const compSeason = nav?.season;

    const roundsList = removeFinals
        ? roundsFromStore?.filter(PULSE.app.common.match.isNonFinalRound)
        : roundsFromStore;

    return roundsFromStore &&
        !(Array.isArray(roundsList) && roundsList.length === 0) ? (
        <div
            className={`stats-leaders-nav__select competition-nav__competition-select ${className}`}
        >
            <Select
                items={roundsList}
                {...(hideLabel && {
                    icon: 'calendar'
                })}
                itemToString={(round) => round?.name}
                initialSelectedItem={
                    roundsList && nav.round.id
                        ? roundsList.find((s) => s.id === Number(nav.round.id))
                        : ''
                }
                activeItem={
                    roundsList && nav.round.id
                        ? roundsList.find((s) => s.id === Number(nav.round.id))
                        : ''
                }
                isReadyToRender={() =>
                    roundsList?.length && Number(nav.round.id)
                }
                label={getTranslation('label.stats.round')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeRound({
                            round: selectedItem
                        })
                    );
                }}
                currentRoundIndex={compSeason?.currentRoundNumber - 1 || false}
                hideLabel={hideLabel}
            />
        </div>
    ) : null;
};

RoundSelectNavItem.propTypes = {
    removeFinals: PropTypes.bool,
    hideLabel: PropTypes.bool,
    className: PropTypes.string
};
